window.isScreenWidthSmallerThan = function (screenWidth) {
  return window.innerWidth < screenWidth;
}

window.isMobileScreenWidth = function () {
  return isScreenWidthSmallerThan(992);
}